import { useDispatch, useSelector } from "../../../../hooks";
import { BusinessNameField } from "./BusinessNameField/BusinessNameField";
import { setBusinessName } from "../../../../redux/businesses/set-business-name.handler";
import styles from "./BusinessHeader.module.scss";
import mainImage from "../images/main.jpg";
import currenyIcon from "../../../../icons/currency.png";
import { formatNumberWithSpaces } from "../../../../utils/numbers";

export const BusinessHeader = () => {
    const dispatch = useDispatch();
    const { lib, activeBusiness: business } = useSelector(store => store.businesses);

    if (!business)
        return <></>;

    const setNameHandler = (newName: string) => {
        if (business)
            dispatch(setBusinessName({ businessType: business.type, name: newName} ));
    }

    const getBusinessName = () => lib.find(businessLib => businessLib.id === business.type)?.name ?? '';

    return (
        <>
            <div className={styles.imageWrapper}>
                <img src={mainImage} alt="Бизнес" className={styles.businessImage} />
                
                <span className={styles.businessType}>{ getBusinessName() }</span>
                
                <BusinessNameField
                    name={ business.name }
                    onChangeNameHandler={ setNameHandler }
                />
            </div>

            <div className={styles.contentWrapper}>
                <div>
                    <div className={styles.incomeRow}>
                        <span className={styles.incomeLabel}>Доход в час</span>
                        <div className={styles.incomeValue}>
                            <img src={currenyIcon} alt="currency" />
                            <span>{ formatNumberWithSpaces(business.profit) }</span>
                        </div>
                    </div>

                    { /* <div className={styles.progressBar}>
                        <div className={styles.progress} style={{ width: `${business.progress}%` }}></div>
                    </div>

                    <span className={styles.incomeNote}>
                        Ваш результат лучше, чем у { business.progress }% игроков
                    </span> */ }
                </div>
            </div>
        </>
    );
}